import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import job_review_with_sales_Service from "./JobReviewsService";
import { toast } from "react-toastify";
const initialState = {
  job_reviews: {},
  isError: false,
  isSuccess: false,
  isLodaing: false,
  massage: "",
};

export const store_job_reviews = createAsyncThunk(
  "job_review/post",
  async (data, thunkAPI) => {
    try {
      return await job_review_with_sales_Service.store_job_review_with_sales(
        data
      );
    } catch (error) {
      const massage =
        (error.response &&
          error.response.data &&
          error.response.data.massage) ||
        error.response.data.error ||
        error.message ||
        error.toString();
      error?.response?.data?.errors?.map((err) =>
        toast.error(err.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
      );
      return thunkAPI.rejectWithValue(massage);
    }
  }
);

export const get_job_reviews_data = createAsyncThunk(
  "job_reviews/get",
  async (ticket_id, thunkAPI) => {
    try {
      return await job_review_with_sales_Service.get_job_review_with_sales_data(
        ticket_id
      );
    } catch (error) {
      const massage =
        (error.response &&
          error.response.data &&
          error.response.data.massage) ||
        error.response.data.error ||
        error.message ||
        error.toString();

      return thunkAPI.rejectWithValue(massage);
    }
  }
);

export const update_job_reviews_data = createAsyncThunk(
  "job_reviews/post",
  async (data, thunkAPI) => {
    try {
      return await job_review_with_sales_Service.edit_job_review_with_sales_data(
        data
      );
    } catch (error) {
      const massage =
        (error.response &&
          error.response.data &&
          error.response.data.massage) ||
        error.response.data.error ||
        error.message ||
        error.toString();
      error?.response?.data?.errors?.map((err) =>
        toast.error(err.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
      );
      return thunkAPI.rejectWithValue(massage);
    }
  }
);

export const job_reviewsSlice = createSlice({
  name: "job_reviews",
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLodaing = false;
      state.massage = "";
    },
  },
  extraReducers: {
    //store_job_reviews
    [store_job_reviews.pending]: (state) => {
      state.isLodaing = true;
    },
    [store_job_reviews.fulfilled]: (state, { payload }) => {
      state.isLodaing = false;
      state.isSuccess = true;
      state.job_reviews = payload;
    },
    [store_job_reviews.rejected]: (state, action) => {
      state.isLodaing = false;
      state.isError = true;
      state.massage = action.payload;
    },

    //get_job_reviews_data
    [get_job_reviews_data.pending]: (state) => {
      state.isLodaing = true;
    },
    [get_job_reviews_data.fulfilled]: (state, { payload }) => {
      state.isLodaing = false;
      state.isSuccess = true;
      state.job_reviews = payload;
    },
    [get_job_reviews_data.rejected]: (state, action) => {
      state.isLodaing = false;
      state.isError = true;
      state.job_reviews = null;
      state.massage = action.payload;
    },

    //update_job_reviews_data
    [update_job_reviews_data.pending]: (state) => {
      state.isLodaing = true;
    },
    [update_job_reviews_data.fulfilled]: (state, { payload }) => {
      state.isLodaing = false;
      state.isSuccess = true;
      state.job_reviews = payload;
    },
    [update_job_reviews_data.rejected]: (state, action) => {
      state.isLodaing = false;
      state.isError = true;
      state.massage = action.payload;
    },
  },
});

export const { reset } = job_reviewsSlice.actions;
export default job_reviewsSlice.reducer;
